var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75006 30.25V21.2162M12.5001 15.125H12.5138M12.5001 9.625H12.5138M15.25 21.2162V30.25M16.625 22C15.435 21.1075 13.9876 20.625 12.5001 20.625C11.0125 20.625 9.56509 21.1075 8.37506 22M18 15.125H18.0138M18 9.625H18.0138M7.00006 15.125H7.01381M7.00006 9.625H7.01381",
    stroke: "#EBB42C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2.75003H4.25006C2.73128 2.75003 1.50006 3.98124 1.50006 5.50002V27.5C1.50006 29.0188 2.73128 30.25 4.25006 30.25H20.75C22.2688 30.25 23.5 29.0188 23.5 27.5V5.50002C23.5 3.98124 22.2688 2.75003 20.75 2.75003Z",
    stroke: "#EBB42C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 31,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.d93c30eeebcc1b23b673d6771a76e1b2.svg";
export { ForwardRef as ReactComponent };